export enum Action {
  //Auth
  AUTH_REGISTER_INIT, AUTH_REGISTER_SUCCESS, AUTH_REGISTER_FAIL,
  BETA_REGISTER_INIT, BETA_REGISTER_SUCCESS, BETA_REGISTER_FAIL,
  AUTH_LOGIN_INIT, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAIL,
  PASSWORD_CHANGE_INIT, PASSWORD_CHANGE_SUCCESS, PASSWORD_CHANGE_FAIL,
  GET_LOGINUSER_PROFILE_INIT, GET_LOGINUSER_PROFILE_SUCCESS, GET_LOGINUSER_PROFILE_FAIL,

  //Account Switching
  INITIALIZE_ACCOUNT_STATE,
  SWITCH_ACCOUNT_INIT, SWITCH_ACCOUNT_SUCCESS, SWITCH_ACCOUNT_FAIL,
  GET_ACCOUNT_PERMISSIONS_INIT, GET_ACCOUNT_PERMISSIONS_SUCCESS, GET_ACCOUNT_PERMISSIONS_FAIL,
  SWITCH_BACK_TO_ADMIN_INIT, SWITCH_BACK_TO_ADMIN_SUCCESS, SWITCH_BACK_TO_ADMIN_FAIL,
  TOGGLE_ADMIN_PERMISSION_MODE,

  //Blobs
  CREATE_BLOB_INIT, CREATE_BLOB_SUCCESS, CREATE_BLOB_FAIL, CREATE_BLOB_PROGRESS,
  GET_BLOB_URL_INIT, GET_BLOB_URL_SUCCESS, GET_BLOB_URL_FAIL,
  //Assets
  ON_CHANGE_SLIDER, ON_CHANGE_SCALE, ON_CHANGE_LOGO_TRANSFORM,
  GET_ASSET_URL_LIST_INIT, GET_ASSET_URL_LIST_SUCCESS, GET_ASSET_URL_LIST_FAIL,

  GET_ALL_ASSETS_INIT, GET_ALL_ASSETS_SUCCESS, GET_ALL_ASSETS_FAIL,
  POST_CREATE_ASSET_INIT, POST_CREATE_ASSET_SUCCESS, POST_CREATE_ASSET_FAIL,
  POST_UPDATE_ASSET_INIT, POST_UPDATE_ASSET_SUCCESS, POST_UPDATE_ASSET_FAIL,

  //Cart
  POST_ADD_TO_CART_INIT, POST_ADD_TO_CART_SUCCESS, POST_ADD_TO_CART_FAIL,
  POST_REMOVE_FROM_CART_INIT, POST_REMOVE_FROM_CART_SUCCESS, POST_REMOVE_FROM_CART_FAIL,
  GET_CART_INIT, GET_CART_SUCCESS, GET_CART_FAIL,


  //Cards (Scenes)
  CLEAR_CARD_STATE,
  GET_ONE_CARD_INIT, GET_ONE_CARD_SUCCESS, GET_ONE_CARD_FAIL,
  GET_ALL_CARD_INIT, GET_ALL_CARD_SUCCESS, GET_ALL_CARD_FAIL,
  GET_MULTI_CARD_INIT, GET_MULTI_CARD_SUCCESS, GET_MULTI_CARD_FAIL,
  GET_ONE_MARKER_INIT, GET_ONE_MARKER_SUCCESS, GET_ONE_MARKER_FAIL,
  GET_ALL_MARKER_INIT, GET_ALL_MARKER_SUCCESS, GET_ALL_MARKER_FAIL,
  GET_MULTI_MARKER_INIT, GET_MULTI_MARKER_SUCCESS, GET_MULTI_MARKER_FAIL,
  COPY_SCENE_INIT, COPY_SCENE_SUCCESS, COPY_SCENE_FAIL,

  POST_CREATE_CARD_INIT, POST_CREATE_CARD_SUCCESS, POST_CREATE_CARD_FAIL,
  POST_UPDATE_CARD_INIT, POST_UPDATE_CARD_SUCCESS, POST_UPDATE_CARD_FAIL,
  POST_CREATE_MARKER_INIT, POST_CREATE_MARKER_SUCCESS, POST_CREATE_MARKER_FAIL,
  POST_UPDATE_MARKER_INIT, POST_UPDATE_MARKER_SUCCESS, POST_UPDATE_MARKER_FAIL,
  GET_ALL_ORDERS_INIT, GET_ALL_ORDERS_SUCCESS, GET_ALL_ORDERS_FAIL,
  GET_ALL_DELETE_MARKER_INIT, GET_ALL_DELETE_MARKER_SUCCESS, GET_ALL_DELETE_MARKER_FAIL,
  GET_ALL_DELETE_CARD_INIT, GET_ALL_DELETE_CARD_SUCCESS, GET_ALL_DELETE_CARD_FAIL,
  GET_ACTIVE_CARD_INIT, GET_ACTIVE_CARD_SUCCESS, GET_ACTIVE_CARD_FAIL,
  CARD_DELETE_INIT, CARD_DELETE_SUCCESS, CARD_DELETE_FAIL,
  MARKER_DELETE_INIT, MARKER_DELETE_SUCCESS, MARKER_DELETE_FAIL,
  MARKER_PERMANENTLY_DELETE_INIT, MARKER_PERMANENTLY_DELETE_SUCCESS, MARKER_PERMANENTLY_DELETE_FAIL,
  CARD_RESTORE_INIT, CARD_RESTORE_SUCCESS, CARD_RESTORE_FAIL,
  CARD_STATUS_CHANGE_INIT, CARD_STATUS_CHANGE_SUCCESS, CARD_STATUS_CHANGE_FAIL,
  CARD_UPDATE_INIT, CARD_UPDATE_SUCCESS, CARD_UPDATE_FAIL,

  //Analytics
  GET_CARD_ANALYTICS_INIT, GET_CARD_ANALYTICS_SUCCESS, GET_CARD_ANALYTICS_FAIL,
  GET_TODAY_ANALYTICS_INIT, GET_TODAY_ANALYTICS_SUCCESS, GET_TODAY_ANALYTICS_FAIL,
  
  //Admin
  ADMIN_GET_ALLUSER_INIT, ADMIN_GET_ALLUSER_SUCCESS, ADMIN_GET_ALLUSER_FAIL,
  ADMIN_GET_B2B_ACCOUNTS_INIT, ADMIN_GET_B2B_ACCOUNTS_SUCCESS, ADMIN_GET_B2B_ACCOUNTS_FAIL,
  ADMIN_CREATE_B2B_ACCOUNT_INIT, ADMIN_CREATE_B2B_ACCOUNT_SUCCESS, ADMIN_CREATE_B2B_ACCOUNT_FAIL,
  ADMIN_UPDATE_B2B_ACCOUNT_INIT, ADMIN_UPDATE_B2B_ACCOUNT_SUCCESS, ADMIN_UPDATE_B2B_ACCOUNT_FAIL,
  ADMIN_SEND_INVITATION_INIT, ADMIN_SEND_INVITATION_SUCCESS, ADMIN_SEND_INVITATION_FAIL,
  ADMIN_GET_OFFERCODES_INIT, ADMIN_GET_OFFERCODES_SUCCESS, ADMIN_GET_OFFERCODES_FAIL,
  ADMIN_ADD_OFFERCODE_INIT, ADMIN_ADD_OFFERCODE_SUCCESS, ADMIN_ADD_OFFERCODE_FAIL,
  ADMIN_UPDATE_OFFERCODE_INIT, ADMIN_UPDATE_OFFERCODE_SUCCESS, ADMIN_UPDATE_OFFERCODE_FAIL,
  ADMIN_DELETE_OFFERCODE_INIT, ADMIN_DELETE_OFFERCODE_SUCCESS, ADMIN_DELETE_OFFERCODE_FAIL,
  ADMIN_GET_REFERRALS_INIT, ADMIN_GET_REFERRALS_SUCCESS, ADMIN_GET_REFERRALS_FAIL,
  ADMIN_ADD_REFERRAL_INIT, ADMIN_ADD_REFERRAL_SUCCESS, ADMIN_ADD_REFERRAL_FAIL,
  ADMIN_UPDATE_REFERRAL_INIT, ADMIN_UPDATE_REFERRAL_SUCCESS, ADMIN_UPDATE_REFERRAL_FAIL,
  ADMIN_DELETE_REFERRAL_INIT, ADMIN_DELETE_REFERRAL_SUCCESS, ADMIN_DELETE_REFERRAL_FAIL,
  ADMIN_GET_AFFILIATES_INIT, ADMIN_GET_AFFILIATES_SUCCESS, ADMIN_GET_AFFILIATES_FAIL,
  ADMIN_ADD_AFFILIATE_INIT, ADMIN_ADD_AFFILIATE_SUCCESS, ADMIN_ADD_AFFILIATE_FAIL,
  ADMIN_GET_CUSTOM_PLANS_INIT, ADMIN_GET_CUSTOM_PLANS_SUCCESS, ADMIN_GET_CUSTOM_PLANS_FAIL,
  ADMIN_ADD_CUSTOM_PLAN_INIT, ADMIN_ADD_CUSTOM_PLAN_SUCCESS, ADMIN_ADD_CUSTOM_PLAN_FAIL,
  ADMIN_GET_ALLUSER_DOWNLOAD_INIT, ADMIN_GET_ALLUSER_DOWNLOAD_SUCCESS, ADMIN_GET_ALLUSER_DOWNLOAD_FAIL,
  GET_USERBY_ID_INIT, GET_USERBY_ID_SUCCESS, GET_USERBY_ID_FAIL,
  UPDATE_USER_INIT, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL,
  DELETE_USER_INIT, DELETE_USER_SUCCESS, DELETE_USER_FAIL,
  ADD_USER_INIT, ADD_USER_SUCCESS, ADD_USER_FAIL,

  //B2B and Invitations
  GET_USER_INVITATIONS_INIT, GET_USER_INVITATIONS_SUCCESS, GET_USER_INVITATIONS_FAIL,
  
  //Plan and Payment
  GET_ALL_PLAN_INIT, GET_ALL_PLAN_SUCCESS, GET_ALL_PLAN_FAIL,
  GET_SINGLE_PLAN_INIT, GET_SINGLE_PLAN_SUCCESS, GET_SINGLE_PLAN_FAIL,
  UPDATE_PLAN_INIT, UPDATE_PLAN_SUCCESS, UPDATE_PLAN_FAIL,
  AUTH_STATE_CHANGED,
  GET_PAYMENT_STATUS_INIT, GET_PAYMENT_STATUS_SUCCESS, GET_PAYMENT_STATUS_FAIL,
  USER_PAYMENT_INIT, USER_PAYMENT_SUCCESS, USER_PAYMENT_FAIL,

  //Files or Misc
  GET_IMAGES_INIT, GET_IMAGES_SUCCESS, GET_IMAGES_FAIL,
  GET_VIDEOS_INIT, GET_VIDEOS_SUCCESS, GET_VIDEOS_FAIL,
  GET_PRODUCTS_INIT, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAIL,

  //Sharing
  SHARE_MARKER_INIT, SHARE_MARKER_SUCCESS, SHARE_MARKER_FAIL,
  GET_SHARED_MARKERS_INIT, GET_SHARED_MARKERS_SUCCESS, GET_SHARED_MARKERS_FAIL,
  GET_MARKER_ANALYTICS_INIT, GET_MARKER_ANALYTICS_SUCCESS, GET_MARKER_ANALYTICS_FAIL,
  GET_SHAREABLE_ACCOUNTS_INIT, GET_SHAREABLE_ACCOUNTS_SUCCESS, GET_SHAREABLE_ACCOUNTS_FAIL,
  
  //Plan Features
  ADMIN_GET_PLAN_FEATURES_INIT, ADMIN_GET_PLAN_FEATURES_SUCCESS, ADMIN_GET_PLAN_FEATURES_FAIL
}




